import React from 'react';
import { Route } from 'react-router-dom';

import { OperatorRoute } from './PrivateRoute';
import {
  OPERATOR_COMPANIES_PATH,
  OPERATOR_COMPANY_NEW_PATH,
  OPERATOR_COMPANY_PATH,
  OPERATOR_OPERATORS_PATH,
  OPERATOR_PATH,
  OPERATOR_SUPPORT_PATH,
} from './pathName';
import OperatorLayout from 'components/Operator/OperatorLayout';
import OperatorDashboard from 'components/Operator/OperatorDashboard';
import CompanyList from 'components/Operator/CompanyList';
import CompanyCreate from 'components/Operator/CompanyCreate';
import CompanyDetail from 'components/Operator/CompanyDetail';
import OperatorList from 'components/Operator/OperatorList';
import SupportAccessList from 'components/Support/SupportAccessList';

/**
 * YAC-2026-009 PR5a・PR5b。運営の画面の経路。PrivateRoute の内側に置く（router/index.tsx）。
 * 運営の役割が要る（OperatorRoute。管理者だけのアカウントは自社の画面へ、役割が無ければログインへ）。
 * 試験でも同じ経路を使えるよう、要素として切り出した。
 */
export const operatorRoutes = (
  <Route element={<OperatorRoute />}>
    <Route element={<OperatorLayout />}>
      <Route path={OPERATOR_PATH} element={<OperatorDashboard />} />
      <Route path={OPERATOR_COMPANIES_PATH} element={<CompanyList />} />
      <Route path={OPERATOR_COMPANY_NEW_PATH} element={<CompanyCreate />} />
      <Route path={OPERATOR_COMPANY_PATH} element={<CompanyDetail />} />
      <Route path={OPERATOR_OPERATORS_PATH} element={<OperatorList />} />
      <Route path={OPERATOR_SUPPORT_PATH} element={<SupportAccessList />} />
    </Route>
  </Route>
);
